var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 507.066 507.066",
    style: {
      enableBackground: "new 0 0 507.066 507.066"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 229.533,
    y: 53.6,
    style: {
      fill: "#D38200"
    },
    width: 72,
    height: 280
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EA990A"
    },
    cx: 195.933,
    cy: 104.8,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D38200"
    },
    d: "M195.933,78.4c17.6,0,32,12,32,26.4s-14.4,26.4-32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M191.133,87.2c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C184.733,85.6,190.333,84.8,191.133,87.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EA990A"
    },
    cx: 189.533,
    cy: 153.6,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D38200"
    },
    d: "M189.533,127.2c17.6,0,32,12,32,26.4s-14.4,26.4-32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M184.733,136c0.8,2.4-3.2,7.2-8.8,10.4s-11.2,4-12,1.6s3.2-7.2,8.8-10.4S183.933,133.6,184.733,136z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EA990A"
    },
    cx: 183.133,
    cy: 202.4,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D38200"
    },
    d: "M183.133,176c17.6,0,32,12,32,26.4s-14.4,26.4-32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M178.333,184.8c0.8,2.4-3.2,7.2-8.8,10.4s-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C171.933,183.2,176.733,182.4,178.333,184.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EA990A"
    },
    cx: 180.733,
    cy: 251.2,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D38200"
    },
    d: "M180.733,224.8c17.6,0,32,12,32,26.4c0,14.4-14.4,26.4-32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M175.933,233.6c0.8,2.4-3.2,7.2-8.8,10.4s-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C169.533,232,175.133,231.2,175.933,233.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EA990A"
    },
    cx: 181.533,
    cy: 300,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D38200"
    },
    d: "M181.533,273.6c17.6,0,32,12,32,26.4s-14.4,26.4-32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M176.733,282.4c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 S175.133,280,176.733,282.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 195.933,
    cy: 348.8,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M195.933,322.4c17.6,0,32,12,32,26.4s-14.4,26.4-32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M191.133,331.2c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C184.733,329.6,190.333,328.8,191.133,331.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 195.933,
    cy: 397.6,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M195.933,371.2c17.6,0,32,12,32,26.4s-14.4,26.4-32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M191.133,380c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C184.733,378.4,190.333,377.6,191.133,380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M259.133,339.2c-53.6-53.6-140-92-192.8-76.8l-0.8-0.8c0,0,0,0,0,0.8c0,0,0,0-0.8,0l0.8,0.8 c-15.2,52,23.2,139.2,76.8,192.8s107.2,59.2,159.2,43.2l0.8,0.8c0,0,0,0,0-0.8c0,0,0,0,0.8,0l-0.8-0.8 C318.333,446.4,313.533,392.8,259.133,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M302.333,499.2L302.333,499.2C302.333,500,302.333,499.2,302.333,499.2c0.8,0,0.8,0,0.8,0H302.333 c16-52.8,11.2-106.4-43.2-160c-53.6-53.6-140-92-192.8-76.8l-0.8-0.8c0,0,0,0,0,0.8c0,0,0,0-0.8,0l0.8,0.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 222.333,
    cy: 64.8,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M217.533,47.2c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C211.133,45.6,216.733,44.8,217.533,47.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 222.333,
    cy: 113.6,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M217.533,96c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C211.133,94.4,216.733,93.6,217.533,96z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 220.733,
    cy: 162.4,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M215.933,144.8c0.8,2.4-3.2,7.2-8.8,10.4s-11.2,4-12,1.6s3.2-7.2,8.8-10.4 S215.133,142.4,215.933,144.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 218.333,
    cy: 211.2,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M213.533,193.6c0.8,2.4-3.2,7.2-8.8,10.4s-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C207.133,192,212.733,191.2,213.533,193.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 218.333,
    cy: 260,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M213.533,242.4c0.8,2.4-3.2,7.2-8.8,10.4s-11.2,4-12,1.6c-0.8-2.4,3.2-7.2,8.8-10.4 S212.733,240,213.533,242.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 222.333,
    cy: 308.8,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M217.533,291.2c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 S216.733,288.8,217.533,291.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 222.333,
    cy: 357.6,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M217.533,340c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 S216.733,337.6,217.533,340z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EA990A"
    },
    cx: 325.533,
    cy: 104.8,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D38200"
    },
    d: "M325.533,78.4c-17.6,0-32,12-32,26.4s14.4,26.4,32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M330.333,87.2c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C336.733,85.6,331.133,84.8,330.333,87.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EA990A"
    },
    cx: 331.933,
    cy: 153.6,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D38200"
    },
    d: "M331.933,127.2c-17.6,0-32,12-32,26.4s14.4,26.4,32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M336.733,136c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C343.133,134.4,337.533,133.6,336.733,136z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EA990A"
    },
    cx: 338.333,
    cy: 202.4,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D38200"
    },
    d: "M339.133,176c-17.6,0-32,12-32,26.4s14.4,26.4,32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M343.933,184.8c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C349.533,183.2,344.733,182.4,343.933,184.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EA990A"
    },
    cx: 340.733,
    cy: 251.2,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D38200"
    },
    d: "M340.733,224.8c-17.6,0-32,12-32,26.4c0,14.4,14.4,26.4,32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M345.533,233.6c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 S346.333,231.2,345.533,233.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EA990A"
    },
    cx: 340.733,
    cy: 300,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D38200"
    },
    d: "M340.733,273.6c-17.6,0-32,12-32,26.4s14.4,26.4,32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M345.533,282.4c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C351.133,280.8,346.333,280,345.533,282.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 325.533,
    cy: 348.8,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M325.533,322.4c-17.6,0-32,12-32,26.4s14.4,26.4,32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M330.333,331.2c-0.8,2.4,3.2,6.4,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C336.733,329.6,331.133,328.8,330.333,331.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 325.533,
    cy: 397.6,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2B630"
    },
    d: "M325.533,371.2c-17.6,0-32,12-32,26.4s14.4,26.4,32,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M330.333,380c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C336.733,378.4,331.133,377.6,330.333,380z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 299.133,
    cy: 64.8,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M303.933,47.2c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C310.333,45.6,304.733,44.8,303.933,47.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 299.133,
    cy: 113.6,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M303.933,96c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C310.333,94.4,304.733,93.6,303.933,96z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 300.733,
    cy: 162.4,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M305.533,144.8c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C311.933,143.2,306.333,142.4,305.533,144.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 303.133,
    cy: 211.2,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M307.933,193.6c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C314.333,192,308.733,191.2,307.933,193.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 303.133,
    cy: 260,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M307.933,242.4c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6c0.8-2.4-3.2-7.2-8.8-10.4 C314.333,240.8,308.733,240,307.933,242.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 299.133,
    cy: 308.8,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M303.933,291.2c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C310.333,289.6,304.733,288.8,303.933,291.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F2B630"
    },
    cx: 299.133,
    cy: 357.6,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA990A"
    },
    d: "M299.133,331.2c-17.6,0-32,12-32,26.4s14.4,26.4,32,26.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M303.933,340c-0.8,2.4,3.2,7.2,8.8,10.4c5.6,3.2,11.2,4,12,1.6s-3.2-7.2-8.8-10.4 C310.333,338.4,304.733,337.6,303.933,340z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 260.733,
    cy: 26.4,
    rx: 32,
    ry: 26.4
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M255.933,8.8c0.8,2.4-3.2,7.2-8.8,10.4s-11.2,4-12,1.6s3.2-7.2,8.8-10.4S255.133,6.4,255.933,8.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 260.733,
    cy: 75.2,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M255.933,57.6c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C249.533,56,255.133,55.2,255.933,57.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 260.733,
    cy: 124,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M255.933,106.4c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 S255.133,104,255.933,106.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 260.733,
    cy: 172.8,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M255.933,155.2c0.8,2.4-3.2,7.2-8.8,10.4s-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C249.533,153.6,255.133,152.8,255.933,155.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 260.733,
    cy: 221.6,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M255.933,204c0.8,2.4-3.2,7.2-8.8,10.4s-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C249.533,201.6,255.133,201.6,255.933,204z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 260.733,
    cy: 270.4,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M255.933,252c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C249.533,250.4,255.133,249.6,255.933,252z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCD50"
    },
    cx: 260.733,
    cy: 319.2,
    rx: 32,
    ry: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ECB7"
    },
    d: "M255.933,300.8c0.8,2.4-3.2,7.2-8.8,10.4c-5.6,3.2-11.2,4-12,1.6s3.2-7.2,8.8-10.4 C249.533,299.2,255.133,298.4,255.933,300.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M247.933,339.2c53.6-53.6,140-92,192.8-76.8l0.8-0.8c0,0,0,0,0,0.8c0,0,0,0,0.8,0l-0.8,0.8 c15.2,52-23.2,139.2-76.8,192.8s-107.2,59.2-159.2,43.2l-0.8,0.8c0,0,0,0,0-0.8c0,0,0,0-0.8,0l0.8-0.8 C188.733,446.4,193.533,392.8,247.933,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M204.733,499.2L204.733,499.2C204.733,500,204.733,499.2,204.733,499.2c-0.8,0-0.8,0-0.8,0H204.733 c-16-52.8-11.2-106.4,43.2-160c53.6-53.6,140-92,192.8-76.8l0.8-0.8c0,0,0,0,0,0.8c0,0,0,0,0.8,0l-0.8,0.8"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorn);
export default __webpack_public_path__ + "static/media/corn.7439e0c938c3f03887e9a89d78325e64.svg";
export { ForwardRef as ReactComponent };